module.exports = __webpack_public_path__ + "img/utility-coins.04eaff76.png";